<template>
  <Drawer
    :drawer="drawer"
    title="操作记录"
    :size="563"
    direction="rtl"
    @close="close"
  >
    <div v-loading="loading" class="view">
      <div class="log-content">
        <div
          v-for="(item, index) in dataList"
          :key="index"
          class="log-item">
          <div class="log-top">
            <img class="avatar" src="@/assets/images/bill/avatar.png">
            <div class="log-created">
              <p>{{ item.createdName }}</p>
              <p>{{ item.createdOn }}</p>
            </div>
            <div :class="['indication', `indication${item.rcordType}`]">{{ item.rcordTypeName }}</div>
          </div>
          <div class="log-bottom">
            <p class="bottom-title">{{ item.rcordTypeName }}：</p>
            <div v-for="(a, aIndex) in item.editJson" :key="aIndex" class="detail-item">
              <div class="log-label flex_c_c">{{ a.propertyName }}</div>
              <div class="log-originalValue">{{ formatText(a.propertyName, a.originalValue) }}</div>
              <template v-if="a.newValue">
                <img src="@/assets/images/bill/log-arrow.png">
                <div class="log-newValue">{{ formatText(a.propertyName, a.newValue) }}</div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Drawer>
</template>

<script>
const Drawer = () => import('@/components/drawer/Drawer')
import { getImporterRecordList } from '@/api/system'
import config from '@/utils/config'
import dayjs from 'dayjs'
export default {
  components: {
    Drawer
  },
  props: {
    drawer: Boolean,
    rowData: Object
  },
  data() {
    return {
      config,
      loading: false,
      dataList: []
    }
  },
  watch: {
    drawer(val) {
      if (val) {
        this.getList()
      }
    }
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const res = await getImporterRecordList({ importerId: this.rowData.id })
        this.loading = false
        if (res.success) {
          this.dataList = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    close() {
      this.$emit('close')
    },
    formatText(type, val) {
      const obj = {
        '年审时间': dayjs(val).format('YYYY-MM-DD'),
        '注册时间': dayjs(val).format('YYYY-MM-DD'),
        '生效日期': dayjs(val).format('YYYY-MM-DD'),
        '截止日期': dayjs(val).format('YYYY-MM-DD'),
        '报税截止时间': dayjs(val).format('YYYY-MM-DD'),
        '注销时间': dayjs(val).format('YYYY-MM-DD'),
        '月结是否': val ? '是' : '否',
        '禁用是否': val ? '是' : '否',
        'BOI是否': val ? '是' : '否',
        '是否注销': val ? '是' : '否',
        '状态': this.config.importerStatusOptions.find(a => a.value === val)?.label
      }
      return obj[type] || val
    }
  }
}
</script>

<style lang="less" scoped>
.title-mark {
  display: inline-block;
  height: 32px;
  border-radius: 4px 4px 4px 4px;
  padding: 0 10px;
  box-sizing: border-box;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  line-height: 32px;
  background: #d9ffef;
  color: #35ba83;
  margin-left: 15px;
}
.view {
  width: 100%;
  height: calc(100vh - 110px);
  box-sizing: border-box;
  overflow-y: auto;
  background: #FBFBFB;
  padding-bottom: 20px;
  box-sizing: border-box;
  .log-content {
    width: calc(100% - 64px);
    margin: 0 auto;
    .log-item {
      width: 100%;
      margin-top: 16px;
      .log-top {
        position: relative;
        display: flex;
        align-items: center;
        .avatar {
          margin-right: 10px;
        }
        .log-created {
          & > p:first-child {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
          }
          & > p:last-child {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 12px;
            color: #999999;
          }
        }
        .indication {
          position: absolute;
          right: 0;
          bottom: 0;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #35BA83;
          &.indication1,
          &.indication2 {
            color: #2395F3;
          }
        }
      }
      .log-bottom {
        position: relative;
        width: calc(100% - 50px);
        margin-left: 50px;
        margin-top: 13px;
        background: #FFFFFF;
        border-radius: 6px 6px 6px 6px;
        box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.12);
        padding: 12px 16px;
        box-sizing: border-box;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        &::before {
          content: '';
          position: absolute;
          top: -20px;
          left: 14px;
          display: inline-block;
          width: 0;
          height: 0;
          border-top: 10px solid transparent;
          border-bottom: 10px solid #D9D9D9;
          border-right: 10px solid transparent;
          border-left: 10px solid transparent;
        }
        &::after {
          content: '';
          position: absolute;
          top: -19px;
          left: 14px;
          display: inline-block;
          width: 0;
          height: 0;
          border-top: 10px solid transparent;
          border-bottom: 10px solid #FFFFFF;
          border-right: 10px solid transparent;
          border-left: 10px solid transparent;
        }
        .bottom-title {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: bold;
          font-size: 14px;
          color: #666666;
          margin-bottom: 8px;
        }
        .detail-item {
          display: flex;
          align-items: center;
          & + .detail-item {
            margin-top: 6px;
          }
          .log-label {
            min-width: 100px;
            height: 24px;
            background: #F1F3F8;
            border-radius: 4px 0px 0px 4px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 12px;
            color: #142E79;
            margin-right: 16px;
          }
          .log-originalValue,
          .log-newValue {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 12px;
            color: #000000;
          }
          .log-originalValue {
            margin-right: 10px;
          }
          img {
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>
